export default __webpack_public_path__ + "static/media/nodejs.9fea1c7d.png";